import React, {useContext} from 'react';
import { AppContext } from '../../../services/translationContext';
import './events.scss';
import { Link, NavLink, useParams } from "react-router-dom";
import PinDropOutlinedIcon from '@mui/icons-material/PinDropOutlined';
import CalendarTodayOutlinedIcon from '@mui/icons-material/CalendarTodayOutlined';

const eventsList = [
  {
    "link": "https://www.odoo.com/it_IT/event/business-show-firenze-9750/register?utm_campaign=20260310-business-show-firenze-it&utm_source=partner-sydea&utm_medium=partner",
    "image": "https://odoocdn.com/openerp_website/static/src/img/odoo-experience/2025/introduction-business-solution.webp",
    "title": "Odoo Business Show",
    "where": "Firenze",
    "date": "10/03/2026",
    "textButton": "register_now"
  }
];

export const EventsSection = ({isMenu = false}) => {
  const { services: {TranslationsService} } = useContext(AppContext);
  const { lang } = useParams();

  const formatDate = (dateString) => {
    const [day, month, year] = dateString.split("/");
    const date = new Date(`${year}-${month}-${day}`);
    const locale = lang === "it" ? "it-IT" : "en-GB";
    return date.toLocaleDateString(locale, {
      day: "numeric",
      month: "short",
      year: "numeric",
    });
  };

  return (
    <div className={`${isMenu ? '':'bkg-light'} d-flex flex-column`}>
      {!isMenu &&<h2 className='syd-title dark fw-bold text-uppercase pt-5 pb-3 px-3'>{TranslationsService.labels('upcoming_events')}</h2>}

      <div className={`${isMenu ? '':'p-3'} d-flex flex-column`}>
        <div className='row gap-3 gap-lg-0'>
        {
            eventsList.map((slider, i) => (
            <div className='col-sm-12 col-lg-3' key={i}>
              {
                // slider.internal_link ?
                // (
                  <Link to={slider.link} className='insights-card-prev text-deco-none tile-client-story' target='_blank'>
                    <div className='syd-box flat d-flex position-relative p-0 overflow-hidden syd-client-stories-box'>
                      <img src={slider.image} alt={slider.title} className='insights-image transition-03s-eio client-story-tile-img'></img>
                      <div className='d-flex flex-column h-100 w-100 p-3 bkg-tile-client-story' style={{zIndex:1}}>
                        <div style={{width:'100%', display:'flex', justifyContent: 'end'}}>
                          <CalendarTodayOutlinedIcon style={{color: '#f6f6f6', fontSize: '0.9rem', marginRight:'0.3rem'}}/><span style={{color: '#f6f6f6', fontSize: '0.9rem', lineHeight: '0.9rem'}}>{formatDate(slider.date)}</span>
                        </div>
                         <div className='tile-center-events'>
                          <h4 className="fw-bold" style={{color: '#f6f6f6', fontSize: '2.7rem', lineHeight: '2.7rem'}}>{slider.title}</h4>
                          <h5 style={{color: '#f6f6f6', fontSize: '1rem', lineHeight: '1rem'}}><PinDropOutlinedIcon style={{fontSize:'1rem', marginRight:'0.3rem'}}/>{slider.where}</h5>
                        </div>
                        <div className='btn-action-event mt-3'>
                          <p className='m-0'>{TranslationsService.labels(slider.textButton)}</p>
                        </div>
                      </div>
                    </div>
                    {/* <div className='syd-box flat d-flex position-relative p-0 overflow-hidden syd-client-stories-box'>
                      <img src={slider.image} alt={slider.title} className='insights-image transition-03s-eio client-story-tile-img'></img>
                      <div className='body-stories-sect d-flex flex-column h-100 w-100 p-4 pt-0 bkg-tile-client-story syd-vertical-box-body'>
                        <h4 className="fw-bold" style={{color: '#f6f6f6', fontSize: '3rem', lineHeight: '3rem'}}>{slider.title}</h4>
                        <h5 style={{color: '#f6f6f6', fontSize: '1.2rem', lineHeight: '1.2rem'}}><PinDropOutlinedIcon />{slider.where}</h5>
                        <div style={{width:'100%', display:'flex', justifyContent: 'end'}}>
                          <span style={{color: '#f6f6f6', fontSize: '0.9rem', lineHeight: '0.9rem'}}>{formatDate(slider.date)}</span>
                        </div>
                        <div className='btn-action-event mt-3'>
                          <p className='m-0'>{TranslationsService.labels(slider.textButton)}</p>
                        </div>
                      </div>
                    </div> */}
                  </Link>
                  // <Link to={`${slider.internal_link}`} className='insights-card text-deco-none transition-03s-eio'>
                  //   <img className='insights-image transition-03s-eio' src={slider.image} alt={slider.title}></img>
                  //   <div className='insights-card-content'>
                  //     <div className='insights-card-body'>
                  //       <h4 className='insights-title-card m-0 fw-bold'>{slider.title}</h4>
                  //     </div>
                  //   </div>
                  // </Link>
                // )
                // :
                // (
                //   <a href={slider.external_link} target='_blank' className='insights-card text-deco-none transition-03s-eio'>
                //     <img className='insights-image transition-03s-eio' src={slider.image} alt={slider.title}></img>
                //     <div className='insights-card-content'>
                //       <div className='insights-card-body'>
                //         <h4 className='insights-title-card m-0 fw-bold'>{slider.title}</h4>
                //       </div>
                //     </div>
                //   </a>
                // )
              }
            </div>
            ))
          }
        </div>
      </div>
    </div>
  );
};